







import { Component, Vue } from 'vue-property-decorator';
import store from '@/store';
import cart from '@/store/modules/cart';
import { TotalSegment } from '@/store/models';
import checkout from '@/store/modules/checkout';

@Component({
    components: {},
})
export default class TaxAmount extends Vue {
    get taxAmount() {
        return cart.totals.tax_amount;
    }

    get totalSegments(): TotalSegment[] {
        return cart.totals.total_segments;
    }

    get isShowable() {
        const taxruleTotal = this.totalSegments.find((segment) => segment.code === 'wf_tax_rule');
        if (taxruleTotal && taxruleTotal.value < 0) {
            return false;
        }
        return true;
    }

    get showTaxAmount() {
        return store.state.options.store_code !== 'it_it';
    }

    get totalSegmentTax(): TotalSegment | undefined {
        return this.totalSegments.find((segment) => segment.code === 'tax');
    }

    get taxPercent() {
        if (store.state.options.store_code === 'it_it'
            && !cart.isOnlyGiftCard
            && ((cart.isVirtual && checkout.billingAddress && checkout.billingAddress.country_id === 'CH')
                ||
                (!cart.isVirtual && checkout.shippingAddress && checkout.shippingAddress.country_id === 'CH'))) {
            return '8.1';
        }
        if (
            this.totalSegmentTax &&
            this.totalSegmentTax.extension_attributes &&
            this.totalSegmentTax.extension_attributes.tax_grandtotal_details[0] &&
            this.totalSegmentTax.extension_attributes.tax_grandtotal_details[0].rates[0] &&
            !this.totalSegmentTax.extension_attributes.tax_grandtotal_details[0].rates[0].title.startsWith('IT_SHIP_')
        ) {
            return this.totalSegmentTax.extension_attributes.tax_grandtotal_details[0].rates[0].percent;
        }
        if (!this.showTaxAmount || !cart.isOnlyGiftCard) {
            return '';
        }
        return '22';
    }
}
